import { normalizeFormFields } from "@/lib/normalizeForm";

/** Display name for the submissions table and header. */
export function getSubmissionSubmitterName(data = {}) {
  if (data.full_name?.trim()) return data.full_name.trim();

  const parts = [data.first_name, data.middle_name, data.last_name]
    .map((p) => (typeof p === "string" ? p.trim() : ""))
    .filter(Boolean);
  if (parts.length) return parts.join(" ");

  if (data.digital_signature?.trim()) return data.digital_signature.trim();
  if (data.email?.trim()) return data.email.trim();

  return "Anonymous";
}

export function formatSubmissionValue(value) {
  if (value === undefined || value === null) return "";
  if (Array.isArray(value)) return value.join(", ");
  return String(value);
}

/**
 * Rows for the submission detail modal — same order as the public form fields.
 */
export function getOrderedSubmissionRows(formSlug, data, forms = []) {
  const form = forms.find((f) => f.slug === formSlug);
  const fields = normalizeFormFields(form?.fields);
  const rows = [];
  const seen = new Set();

  for (const field of fields) {
    const key = field.name;
    if (!key || !(key in (data || {}))) continue;
    const value = data[key];
    if (value === undefined || value === null || value === "") continue;
    rows.push({
      key,
      label: field.label || key.replace(/_/g, " "),
      value,
    });
    seen.add(key);
  }

  for (const [key, value] of Object.entries(data || {})) {
    if (seen.has(key) || value === undefined || value === null || value === "") continue;
    rows.push({
      key,
      label: key.replace(/_/g, " "),
      value,
    });
  }

  return rows;
}
